import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/clinic/assets/images/logo-recoma.png'


const _withScopeId = n => (_pushScopeId("data-v-410a92ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reset-password-page" }
const _hoisted_2 = { class: "reset-password-wrapper mx-auto" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo mx-auto",
    src: _imports_0,
    alt: "Logo"
  })
], -1))

import FormResetPassword from "./form.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(FormResetPassword)
    ])
  ]))
}
}

})